import { useTranslation } from '../i18n';

export default function Legend() {
  const { dict } = useTranslation();
  return (
    <div className="legend">
      <div className="legend-item"><div className="l-dot" style={{ background: 'var(--col-a)' }} /><span>{dict.leg_a}</span></div>
      <div className="legend-item"><div className="l-dot" style={{ background: 'var(--col-b)' }} /><span>{dict.leg_b}</span></div>
      <div className="legend-item"><div className="l-dot" style={{ background: 'var(--col-c)' }} /><span>{dict.leg_c}</span></div>
      <div className="legend-item">
        <svg width="22" height="10" viewBox="0 0 22 10" fill="none">
          <line x1="0" y1="5" x2="15" y2="5" stroke="#554E47" strokeWidth="1.5" />
          <path d="M13 1.5L19 5L13 8.5" stroke="#554E47" strokeWidth="1.5" strokeLinecap="round" fill="none" />
        </svg>
        <span>{dict.leg_flow}</span>
      </div>
    </div>
  );
}
